module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "itinerary-page",
    attrs: {
      "id": "itineraryPage"
    }
  }, [(_vm.settings.customFlight) ? _c('div', {
    staticClass: "d-flex align-start sh-nav"
  }, [_c('div', {
    staticClass: "sh-selected d-flex",
    on: {
      "click": function($event) {
        _vm.backLegSelect('leg1')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.leg1Selected.flight[0].logo
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sh-airline"
  }, [_vm._v(_vm._s(_vm.leg1Selected.flightName))]), _vm._v(" "), _c('span', {
    staticClass: "sh-airport"
  }, [_vm._v("\n        " + _vm._s(_vm.leg1Selected.flight[0].origin.AirportCode) + "\n        "), _c('i', {
    staticClass: "fas fa-plane"
  }), _vm._v("\n        " + _vm._s(_vm.leg1Selected.flight[_vm.leg1Selected.flight.length - 1].destination.AirportCode) + "\n      ")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  }), _vm._v(" "), (_vm.isReturning) ? _c('div', {
    staticClass: "sh-selected d-flex",
    on: {
      "click": function($event) {
        _vm.backLegSelect('leg2')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.leg2Selected.flight[0].logo
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sh-airline"
  }, [_vm._v(_vm._s(_vm.leg2Selected.flightName))]), _vm._v(" "), _c('span', {
    staticClass: "sh-airport"
  }, [_vm._v("\n        " + _vm._s(_vm.leg2Selected.flight[0].origin.AirportCode) + "\n        "), _c('i', {
    staticClass: "fas fa-plane"
  }), _vm._v("\n        " + _vm._s(_vm.leg2Selected.flight[_vm.leg2Selected.flight.length - 1].destination.AirportCode) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.isReturning) ? _c('i', {
    staticClass: "fas fa-chevron-right"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "default-txt review-trip active"
  }, [_vm._v("Review trip")])]) : _c('a', {
    staticClass: "back-to-home",
    on: {
      "click": function($event) {
        _vm.backLegSelect('leg1')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-double-left"
  }), _vm._v("\n    Back to Flight List\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "it-page-header"
  }, [_vm._v("Your itinerary")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex it-page-body align-start"
  }, [_c('div', {
    staticClass: "it-body-details"
  }, [_c('div', {
    staticClass: "flight-details-box it-page-box"
  }, [(_vm.isReturning) ? _c('div', {
    staticClass: "fd-header"
  }, [_c('i', {
    staticClass: "fas fa-plane"
  }), _vm._v(" "), _c('span', [_vm._v("Roundtrip")])]) : _vm._e(), _vm._v(" "), _c('flight-details-box', {
    attrs: {
      "legSelected": _vm.leg1Selected,
      "leg": "leg1"
    }
  }), _vm._v(" "), (_vm.leg1Selected.flight.length > 1) ? _c('div', {
    staticClass: "fd-trigger",
    on: {
      "click": function($event) {
        _vm.showFlightDetails('leg1')
      }
    }
  }, [_vm._v("Flight Details")]) : _vm._e(), _vm._v(" "), (_vm.isReturning) ? _c('hr', {
    staticClass: "fd-hr"
  }) : _vm._e(), _vm._v(" "), (_vm.isReturning) ? _c('flight-details-box', {
    attrs: {
      "legSelected": _vm.leg2Selected,
      "leg": "leg2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isReturning && (_vm.leg2Selected.returnFlight.length > 1 || (_vm.settings.customFlight && _vm.leg2Selected.flight.length > 1))) ? _c('div', {
    staticClass: "fd-trigger",
    on: {
      "click": function($event) {
        _vm.showFlightDetails('leg2')
      }
    }
  }, [_vm._v("\n          Flight Details\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.booking.includedLandTranspo.length) ? _c('div', {
    staticClass: "ground-trans-box"
  }, [_c('div', {
    staticClass: "gt-header"
  }, [_vm._v("We pick a ride for you")]), _vm._v(" "), (!_vm.hideGround.pickup || !_vm.hideGround.dropoff) ? _c('div', {
    staticClass: "gt-box it-page-box"
  }, [(!_vm.hideGround.pickup) ? _c('div', {
    class: ['d-flex justify-space-between gt-ride', {
      'skip-ride': _vm.booking.includedLandTranspo.indexOf(0) === -1
    }]
  }, [_c('div', {
    staticClass: "gt-details"
  }, [_c('div', {
    staticClass: "gt-r-header"
  }, [_vm._v("Ground Transportation (Leg 1)")]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-service d-flex align-center"
  }, [_c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-r-status"
  }, [_vm._v("Upcoming")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg1', 'pickup').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-locations d-flex align-start"
  }, [_c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground1PU
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground1PU = !_vm.wrap.ground1PU
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.pickup.title))]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Pickup Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.pickupDetails.pickupTime.leg1, true)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.pickupDetails.pickupTime.leg1, true)) + "\n                  ")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground1DO
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground1DO = !_vm.wrap.ground1DO
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.pickupAirport.name) + " (" + _vm._s(_vm.locations.pickupAirport.code) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Dropoff Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.pickupDetails.pickupTime.leg1, true, _vm.landQuote.leg1Depart.eta)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.pickupDetails.pickupTime.leg1, true, _vm.landQuote.leg1Depart.eta)) + "\n                  ")])])]), _vm._v(" "), _c('label', {
    staticClass: "gt-skip"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/car-transport.svg")
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ground0),
      expression: "ground0"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ground0) ? _vm._i(_vm.ground0, null) > -1 : (_vm.ground0)
    },
    on: {
      "click": function($event) {
        _vm.toggleGround(0)
      },
      "__c": function($event) {
        var $$a = _vm.ground0,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.ground0 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ground0 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ground0 = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gt-action",
    on: {
      "click": function($event) {
        _vm.changeRide('leg1', 'pickup')
      }
    }
  }, [(_vm.leg1Free) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v("FREE")]) : _c('div', [(_vm.leg1Discount.value > 0) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v(_vm._s(((_vm.dcLabel(_vm.leg1Discount)) + " OFF")))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.findById('leg1', 'pickup')))]), _vm._v(" "), (_vm.leg1Discount.value > 0) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg1', 'pickup'), false), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg1', 'pickup'), false))))])]) : (_vm.findById('leg1', 'pickup').price != _vm.findById('leg1', 'pickup').origPrice) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg1', 'pickup'), false, 'origPrice'), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg1', 'pickup'), false, 'origPrice'))))])]) : _vm._e(), _vm._v(" "), (_vm.currency.code === 'USD') ? _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg1', 'pickup'), 'Leg1'), true)))]) : _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg1', 'pickup'), 'Leg1'))))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.findById('leg1', 'pickup').img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-capacity d-flex justify-center"
  }, [_c('div', [_c('i', {
    staticClass: "far fa-user"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg1', 'pickup').maxPax) + "\n                ")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-suitcase"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg1', 'pickup').maxLuggage) + "\n                ")])]), _vm._v(" "), _c('a', [_vm._v("Change ride")])])]) : _vm._e(), _vm._v(" "), (!_vm.hideGround.pickup && !_vm.hideGround.dropoff) ? _c('hr') : _vm._e(), _vm._v(" "), (!_vm.hideGround.dropoff) ? _c('div', {
    class: ['d-flex justify-space-between gt-ride', {
      'skip-ride': _vm.booking.includedLandTranspo.indexOf(1) === -1
    }]
  }, [_c('div', {
    staticClass: "gt-details"
  }, [_c('div', {
    staticClass: "gt-r-service d-flex align-center"
  }, [_c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-r-status"
  }, [_vm._v("Upcoming")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg1', 'dropoff').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-locations d-flex align-start"
  }, [_c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground2PU
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground2PU = !_vm.wrap.ground2PU
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.dropoffAirport.name) + " (" + _vm._s(_vm.locations.dropoffAirport.code) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Pickup Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.dropoffDetails.pickupTime.leg1, true)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.dropoffDetails.pickupTime.leg1, true)) + "\n                  ")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground2DO
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground2DO = !_vm.wrap.ground2DO
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.dropoff.title))]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Dropoff Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.dropoffDetails.pickupTime.leg1, true, _vm.landQuote.leg1Arrive.eta)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.dropoffDetails.pickupTime.leg1, true, _vm.landQuote.leg1Arrive.eta)) + "\n                  ")])])]), _vm._v(" "), _c('label', {
    staticClass: "gt-skip"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/car-transport.svg")
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ground1),
      expression: "ground1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ground1) ? _vm._i(_vm.ground1, null) > -1 : (_vm.ground1)
    },
    on: {
      "click": function($event) {
        _vm.toggleGround(1)
      },
      "__c": function($event) {
        var $$a = _vm.ground1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.ground1 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ground1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ground1 = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gt-action",
    on: {
      "click": function($event) {
        _vm.changeRide('leg1', 'dropoff')
      }
    }
  }, [(_vm.leg2Free) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v("FREE")]) : _c('div', [(_vm.leg2Discount.value > 0) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v(_vm._s(((_vm.dcLabel(_vm.leg2Discount)) + " OFF")))]) : _vm._e(), _vm._v(" "), (_vm.leg2Discount.value > 0) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg1', 'dropoff'), false), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg1', 'dropoff'), false))))])]) : (_vm.findById('leg1', 'dropoff').price != _vm.findById('leg1', 'dropoff').origPrice) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg1', 'dropoff'), false, 'origPrice'), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg1', 'dropoff'), false, 'origPrice'))))])]) : _vm._e(), _vm._v(" "), (_vm.currency.code === 'USD') ? _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg1', 'dropoff'), 'Leg2'), true)))]) : _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg1', 'dropoff'), 'Leg2'))))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.findById('leg1', 'dropoff').img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-capacity d-flex justify-center"
  }, [_c('div', [_c('i', {
    staticClass: "far fa-user"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg1', 'dropoff').maxPax) + "\n                ")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-suitcase"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg1', 'dropoff').maxLuggage) + "\n                ")])]), _vm._v(" "), _c('a', [_vm._v("Change ride")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isReturning && (!_vm.hideGround.pickup || !_vm.hideGround.dropoff)) ? _c('div', {
    staticClass: "gt-box it-page-box"
  }, [(!_vm.hideGround.dropoff) ? _c('div', {
    class: ['d-flex justify-space-between gt-ride', {
      'skip-ride': _vm.booking.includedLandTranspo.indexOf(2) === -1
    }]
  }, [_c('div', {
    staticClass: "gt-details"
  }, [_c('div', {
    staticClass: "gt-r-header"
  }, [_vm._v("Ground Transportation (Leg 2)")]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-service d-flex align-center"
  }, [_c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-r-status"
  }, [_vm._v("Upcoming")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg2', 'pickup').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-locations d-flex align-start"
  }, [_c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground3PU
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground3PU = !_vm.wrap.ground3PU
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.dropoff.title))]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Pickup Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.pickupDetails.pickupTime.leg2, true)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.pickupDetails.pickupTime.leg2, true)) + "\n                  ")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground3DO
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground3DO = !_vm.wrap.ground3DO
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.dropoffAirport.name) + " (" + _vm._s(_vm.locations.dropoffAirport.code) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Dropoff Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.pickupDetails.pickupTime.leg2, true, _vm.landQuote.leg2Depart.eta)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.pickupDetails.pickupTime.leg2, true, _vm.landQuote.leg2Depart.eta)) + "\n                  ")])])]), _vm._v(" "), _c('label', {
    staticClass: "gt-skip"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/car-transport.svg")
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ground2),
      expression: "ground2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ground2) ? _vm._i(_vm.ground2, null) > -1 : (_vm.ground2)
    },
    on: {
      "click": function($event) {
        _vm.toggleGround(2)
      },
      "__c": function($event) {
        var $$a = _vm.ground2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.ground2 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ground2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ground2 = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gt-action",
    on: {
      "click": function($event) {
        _vm.changeRide('leg2', 'pickup')
      }
    }
  }, [(_vm.leg3Free) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v("FREE")]) : _c('div', [(_vm.leg3Discount.value > 0) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v(_vm._s(((_vm.dcLabel(_vm.leg3Discount)) + " OFF")))]) : _vm._e(), _vm._v(" "), (_vm.leg3Discount.value > 0) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg2', 'pickup'), false), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg2', 'pickup'), false))))])]) : (_vm.findById('leg2', 'pickup').price != _vm.findById('leg2', 'pickup').origPrice) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg2', 'pickup'), false, 'origPrice'), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg2', 'pickup'), false, 'origPrice'))))])]) : _vm._e(), _vm._v(" "), (_vm.currency.code === 'USD') ? _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg2', 'pickup'), 'Leg3'), true)))]) : _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg2', 'pickup'), 'Leg3'))))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.findById('leg2', 'pickup').img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-capacity d-flex justify-center"
  }, [_c('div', [_c('i', {
    staticClass: "far fa-user"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg2', 'pickup').maxPax) + "\n                ")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-suitcase"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg2', 'pickup').maxLuggage) + "\n                ")])]), _vm._v(" "), _c('a', [_vm._v("Change ride")])])]) : _vm._e(), _vm._v(" "), (!_vm.hideGround.pickup && !_vm.hideGround.dropoff) ? _c('hr') : _vm._e(), _vm._v(" "), (!_vm.hideGround.pickup) ? _c('div', {
    class: ['d-flex justify-space-between gt-ride', {
      'skip-ride': _vm.booking.includedLandTranspo.indexOf(3) === -1
    }]
  }, [_c('div', {
    staticClass: "gt-details"
  }, [_c('div', {
    staticClass: "gt-r-service d-flex align-center"
  }, [_c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-r-status"
  }, [_vm._v("Upcoming")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg2', 'dropoff').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-locations d-flex align-start"
  }, [_c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground4PU
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground4PU = !_vm.wrap.ground4PU
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.pickupAirport.name) + " (" + _vm._s(_vm.locations.pickupAirport.code) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Pickup Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.dropoffDetails.pickupTime.leg2, true)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.dropoffDetails.pickupTime.leg2, true)) + "\n                  ")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-car-side"
  }), _vm._v(" "), _c('div', {
    class: ['gt-r-box', {
      'gt-wrap': _vm.wrap.ground4DO
    }]
  }, [_c('span', {
    staticClass: "gt-r-loc-val",
    on: {
      "click": function($event) {
        _vm.wrap.ground4DO = !_vm.wrap.ground4DO
      }
    }
  }, [_vm._v(_vm._s(_vm.locations.pickup.title))]), _vm._v(" "), _c('div', {
    staticClass: "gt-r-value"
  }, [_c('span', [_vm._v("Dropoff Time:")]), _vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.locations.dropoffDetails.pickupTime.leg2, true, _vm.landQuote.leg2Arrive.eta)) + "\n                    ·\n                    " + _vm._s(_vm.timeFormat(_vm.locations.dropoffDetails.pickupTime.leg2, true, _vm.landQuote.leg2Arrive.eta)) + "\n                  ")])])]), _vm._v(" "), _c('label', {
    staticClass: "gt-skip"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/car-transport.svg")
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ground3),
      expression: "ground3"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ground3) ? _vm._i(_vm.ground3, null) > -1 : (_vm.ground3)
    },
    on: {
      "click": function($event) {
        _vm.toggleGround(3)
      },
      "__c": function($event) {
        var $$a = _vm.ground3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.ground3 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ground3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ground3 = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gt-action",
    on: {
      "click": function($event) {
        _vm.changeRide('leg2', 'dropoff')
      }
    }
  }, [(_vm.leg4Free) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v("FREE")]) : _c('div', [(_vm.leg4Discount.value > 0) ? _c('span', {
    staticClass: "free-label"
  }, [_vm._v(_vm._s(((_vm.dcLabel(_vm.leg4Discount)) + " OFF")))]) : _vm._e(), _vm._v(" "), (_vm.leg4Discount.value > 0) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg2', 'dropoff'), false), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg2', 'dropoff'), false))))])]) : (_vm.findById('leg2', 'dropoff').price != _vm.findById('leg2', 'dropoff').origPrice) ? _c('div', {
    staticClass: "ground-price orig"
  }, [(_vm.currency.code === 'USD') ? _c('span', [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg2', 'dropoff'), false, 'origPrice'), true)))]) : _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg2', 'dropoff'), false, 'origPrice'))))])]) : _vm._e(), _vm._v(" "), (_vm.currency.code === 'USD') ? _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.priceFormat(_vm.fullPrice(_vm.findById('leg2', 'dropoff'), 'Leg4'), true)))]) : _c('span', {
    staticClass: "ground-price"
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.fullPrice(_vm.findById('leg2', 'dropoff'), 'Leg4'))))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.findById('leg2', 'dropoff').img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-capacity d-flex justify-center"
  }, [_c('div', [_c('i', {
    staticClass: "far fa-user"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg2', 'dropoff').maxPax) + "\n                ")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-suitcase"
  }), _vm._v("\n                  " + _vm._s(_vm.findById('leg2', 'dropoff').maxLuggage) + "\n                ")])]), _vm._v(" "), _c('a', [_vm._v("Change ride")])])]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "it-body-summary"
  }, [_c('payment-summary')], 1)]), _vm._v(" "), _c('service-select', {
    attrs: {
      "show": _vm.showService,
      "extraData": _vm.extraData
    },
    on: {
      "close": function($event) {
        _vm.showService = false
      }
    }
  }), _vm._v(" "), _c('flight-details-modal', {
    ref: "flightDetailsModal"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-010f23ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010f23ee","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DItinerary/index.vue
// module id = 2023
// module chunks = 0